import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import WochenplanungView from '../views/WochenplanungView.vue'
import RezepteView from '../views/RezepteView.vue'
import RezepteNeuView from '../views/RezepteNeuView.vue'
import RezepteListeView from '../views/RezepteListeView.vue'
import RezepteBearbeitenView from '../views/RezepteBearbeitenView.vue'
import RezepteEingefrorenView from '../views/RezepteEingefrorenView.vue'
import EinkaufslisteView from '../views/EinkaufslisteView.vue'
import EinkaufslisteAnzeigenView from '../views/EinkaufslisteAnzeigenView.vue'
import GekaufteZutatenAnzeigenView from '../views/GekaufteZutatenAnzeigenView.vue'
import ZutatenAnzeigenView from '../views/ZutatenAnzeigenView.vue'
import ZutatenDuplikateView from '../views/ZutatenDuplikateView.vue'
import ZutatenHinzufuegenView from '../views/ZutatenHinzufuegenView.vue'
import ZutatenBearbeitenView from '../views/ZutatenBearbeitenView.vue'
import KategorienAnzeigenView from '../views/KategorienAnzeigenView.vue'
import KategorieHinzufuegenView from '../views/KategorieHinzufuegenView.vue'
import KategorieBearbeitenView from '../views/KategorieBearbeitenView.vue'
import EinstellungenView from '../views/EinstellungenView.vue'
import { Benutzer, SitzungSicherstellen } from '../composables/useBenutzer'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/wochenplanung', name: 'wochenplanung', component: WochenplanungView, meta: { erfordertAnmeldung: true } },
  { path: '/rezepte', name: 'rezepte', component: RezepteView, meta: { erfordertAnmeldung: true } },
  { path: '/rezepte/neu', name: 'rezepte-neu', component: RezepteNeuView, meta: { erfordertAnmeldung: true } },
  { path: '/rezepte/liste', name: 'rezepte-liste', component: RezepteListeView, meta: { erfordertAnmeldung: true } },
  { path: '/rezepte/bearbeiten/:id', name: 'rezepte-bearbeiten', component: RezepteBearbeitenView, meta: { erfordertAnmeldung: true } },
  { path: '/rezepte/eingefroren', name: 'rezepte-eingefroren', component: RezepteEingefrorenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste', name: 'einkaufsliste', component: EinkaufslisteView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/anzeigen', name: 'einkaufsliste-anzeigen', component: EinkaufslisteAnzeigenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/gekauft', name: 'einkaufsliste-gekauft', component: GekaufteZutatenAnzeigenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/zutaten-anzeigen', name: 'zutaten-anzeigen', component: ZutatenAnzeigenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/zutaten-duplikate', name: 'zutaten-duplikate', component: ZutatenDuplikateView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/zutaten-hinzufuegen', name: 'zutaten-hinzufuegen', component: ZutatenHinzufuegenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/zutaten-bearbeiten/:id', name: 'zutaten-bearbeiten', component: ZutatenBearbeitenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/kategorien', name: 'kategorien-anzeigen', component: KategorienAnzeigenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/kategorien/neu', name: 'kategorien-neu', component: KategorieHinzufuegenView, meta: { erfordertAnmeldung: true } },
  { path: '/einkaufsliste/kategorien/bearbeiten/:id', name: 'kategorien-bearbeiten', component: KategorieBearbeitenView, meta: { erfordertAnmeldung: true } },
  { path: '/einstellungen', name: 'einstellungen', component: EinstellungenView, meta: { erfordertAnmeldung: true } }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (!to.meta.erfordertAnmeldung) {
    return true
  }
  await SitzungSicherstellen()
  if (!Benutzer.Angemeldet) {
    return '/'
  }
  return true
})

export default router
